export function replace_(value: string): string {
    return value.replaceAll('_', ' ')
}

export function replaceDIAMOND_(value: string): string {
    return replace_(value.replace(`DIAMOND_`, ''))
}

export function replaceFANCY_DIAMOND_(value: string): string {
    return replace_(value.replace(`FANCY_DIAMOND_`, ''))
}

export function formatNumericProperty(value: number): string {
    return value.toFixed(2)
}
